import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=b38d011e"
import script from "./ProductsFilter.vue?vue&type=script&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductsFilter.vue?vue&type=style&index=0&id=b38d011e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports